import {getMemberPhoto} from '../api';
import {addMemberPhoto, addTeamBanner} from '../store/auth';
import {colleaguePlaceholderPhoto, teamPlaceholderPhoto} from '../constants/images';
import {getTeamBanner} from '../api/teams';

export async function retrieveMemberPhoto(memberId, memberPhotos, dispatch) {
	if (memberPhotos) {
		const photoFromStore = memberPhotos.find((item) => item.id === memberId);
		if (photoFromStore) return photoFromStore.photo;
	}
	try {
		const response = await getMemberPhoto(memberId, false);
		if (response.status === 204) throw new Error('no member photo'); // More informative error

		const photoURL = window.URL.createObjectURL(new Blob([response.data]));
		if (dispatch) dispatch(addMemberPhoto(memberId, photoURL));
		return photoURL;
	} catch (error) {
		if (error.message === 'no member photo') {
			if (dispatch) dispatch(addMemberPhoto(memberId, colleaguePlaceholderPhoto));
			return colleaguePlaceholderPhoto;
		} else {
			throw error;
		}
	}
}

export async function retrieveTeamBanner(teamId, teamBanners, dispatch) {
	if (teamBanners) {
		const bannerFromStore = teamBanners.find((item) => item.id === teamId);
		if (bannerFromStore) return bannerFromStore.photo;
	}
	try {
		const response = await getTeamBanner(teamId, true);
		if (response.status === 204) throw new Error('no team banner'); // More informative error

		const bannerURL = window.URL.createObjectURL(new Blob([response.data]));
		if (dispatch) dispatch(addTeamBanner(teamId, bannerURL));
		return bannerURL;
	} catch (error) {
		if (error.message === 'no team banner') {
			if (dispatch) dispatch(addTeamBanner(teamId, teamPlaceholderPhoto));
			return teamPlaceholderPhoto;
		} else {
			throw error;
		}
	}
}
